import { postApi } from '../../../utils/api'

export function performContractsMassAction(data) {
  return postApi({
    data,
    endpoint: 'idwell-api/api/v3/inhabitancy/contracts/mass-action/',
  })
}
